<template>
  <b-dropdown 
    variant="outline-info"
    size="sm"
    right
  >
    <template #button-content>
      <font-awesome-icon
        class="mr-1"
        :icon="['fas', 'info-circle']"
        :style="{ cursor: 'pointer' }"
      /> 
      View
    </template>

    <b-dropdown-item-button 
      variant="info"
      @click="$emit('showApplicationRequestDetails', offerRegistration)"
    >
      <font-awesome-icon
        class="mr-1"
        :icon="['fas', 'wrench']"
        :style="{ cursor: 'pointer' }"
      /> Offer Details
    </b-dropdown-item-button>

    <b-dropdown-divider v-if="showBiddingUrlOption" />

    <b-dropdown-item-button
      v-if="showBiddingUrlOption"
      variant="info"
      @click="$emit('showBiddingUrl', offerRegistration)"
    >
      <font-awesome-icon
        class="mr-1"
        :icon="['fas', 'wrench']"
        :style="{ cursor: 'pointer' }"
      /> Bidding URL
    </b-dropdown-item-button>

    <b-dropdown-divider />

    <b-dropdown-item-button 
      v-if="offerRegistration.status === 'Pending' || offerRegistration.status === 'Approved'"
      variant="info"
      @click="$emit('showWithdrawModal', offerRegistration)"
    >
      <font-awesome-icon
        class="mr-1"
        :icon="['fas', 'pause']"
        :style="{ cursor: 'pointer' }"
      />
      Withdraw
    </b-dropdown-item-button>

    <b-dropdown-divider v-if="offerRegistration.status === 'Approved' && showRingbaIntegrationActions" />

    <b-dropdown-item
      v-if="offerRegistration.status === 'Approved' && showRingbaIntegrationActions"
      variant="info"
      :to="{ 
        name: 'SellerOfferRTTRequest', 
        params: { offerRegistrationId: offerRegistration.id, offerId: offerRegistration.sellerOffer.id } 
      }"
    >
      <font-awesome-icon
        class="mr-1"
        :icon="['fas', 'plus-circle']"
        :style="{ cursor: 'pointer' }"
      />
      Request RTT
    </b-dropdown-item>

    <b-dropdown-divider v-if="offerRegistration.status === 'Approved' && showRingbaIntegrationActions" />

    <b-dropdown-item
      v-if="offerRegistration.status === 'Approved' && showRingbaIntegrationActions"
      variant="info"
      :to="{
        name: 'ListRingTreeTargetRequests', 
        params: { offerRegistrationId: offerRegistration.id, offerId: offerRegistration.sellerOffer.id } 
      }"
    >
      <font-awesome-icon
        class="mr-1"
        :icon="['fas', 'bullseye']"
        :style="{ cursor: 'pointer' }"
      />
      View RTT Requests
    </b-dropdown-item>

    <b-dropdown-item-button 
      v-if="offerRegistration.status === 'Rejected'"
      variant="info"
      @click="$emit('showRejectionModal', offerRegistration)"
    >
      <font-awesome-icon
        class="mr-1"
        :icon="['fas', 'ban']"
        :style="{ cursor: 'pointer' }"
      />
      Rejection Reason
    </b-dropdown-item-button>
  </b-dropdown>
</template>

<script>
export default {
  name: 'SellerAppliedOfferActions',

  props: {
    offerRegistration: {
      type: Object,
      default() {
        return {}
      }
    },

    showRingbaIntegrationActions: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    showBiddingUrlOption() {
      return this.offerRegistration.status !== 'Pending' 
      && this.offerRegistration.status !== 'Withdrawn' 
      && this.offerRegistration.status !== 'Rejected'
    }
  },
}
</script>
<style lang="">
  
</style>